const messages = {
    login: 'header.buttons.login',
    register: 'header.buttons.register',
    logout: 'header.buttons.logout',
    maintenanceTitle: 'header.maintenance.title',
    maintenanceTooltip: 'header.maintenance.tooltip',
    fetchBalanceError: 'header.notAvailable.tooltip',
    // Account information
    balance: 'header.accInfo.balance',
    accountNo: 'header.accInfo.accountNo',
    sortCode: 'header.accInfo.sortCode',
    availableAmount: 'header.accInfo.availableAmount',
};
export default messages;
//# sourceMappingURL=messages.js.map